import { render, staticRenderFns } from "./AboutFour.vue?vue&type=template&id=107a0c7b"
import script from "./AboutFour.vue?vue&type=script&lang=js"
export * from "./AboutFour.vue?vue&type=script&lang=js"
import style0 from "./AboutFour.vue?vue&type=style&index=0&id=107a0c7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports